import React, { useState, useRef, useMemo, useEffect } from 'react';
import { useFetchWithBody, usePost } from '../../api/reactQueryCustomHooks';
import {
    Box, Button, Grid, Paper, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, TextField, Typography, FormControl, InputLabel,
    Select, MenuItem, IconButton, InputAdornment, Popover, useMediaQuery, Chip, Alert, AlertTitle, ListSubheader,
    CircularProgress,
    ToggleButton,
    ToggleButtonGroup
} from '@mui/material';

import { format } from 'date-fns';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import { apiRoute, ENUM_MOD_NAME, ENUM_MOD_PARAMETER, ENUM_STATUS, getModMandatory, linksUrl } from '../../constants/enum';
import { useSelector } from 'react-redux';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import { Tab, Tabs } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { autoTable } from "jspdf-autotable"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose, faDownload, faDownLong, faFilter, faInfo, faRefresh, faSearch } from '@fortawesome/free-solid-svg-icons';
import { ErrorCard, LoadingCard, MainContainer, MasterGrid, MUIDataTable, NoDataCard } from '../../components';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import dayjs from "dayjs"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { head } from 'lodash';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';



const MixStockDetail = () => {
    const theme = useTheme();
    const navi = useNavigate()
    const { compCode, compName, startDate, endDate } = useSelector((state) => state.company);
    const { mixStockRptDetail } = useSelector((state) => state.stockEntry);


    const columns = [

        {
            header: "Shape", accessor: "Shape_Name", type: "text", filterable: true, sortable: true, footer: {
                type: "count"
            }
        },
        {
            header: "Purity", accessor: "Purity_Name", type: "text", filterable: true, sortable: true, align: "center"
        },
        { header: "Size", accessor: "Size_Name", type: "text", filterable: true, sortable: true, align: "center" },
        {
            header: "Item", accessor: "Item_Name", type: "text", filterable: true, sortable: true,
        },
        {
            header: "Lot No.", accessor: "L_Code", type: "text", filterable: true, sortable: true,
        },
        {
            header: "LW Ratio", accessor: "Lw_Code", type: "text", filterable: true, sortable: true,
        },
        {
            header: "carat", accessor: "Disp_Carat", type: "number", filterable: true, sortable: true, align: "right", footer: {
                type: "last",
                column: "Close_Carat"
            },
            fraction: 3
        },
        { header: "Rate", accessor: "Rate", type: "number", filterable: true, sortable: true, align: "right", footer: { type: "avg", column: ["Cost_AmtRs", "Cost_Carat"] } },
        { header: "Date", accessor: "Trn_Date", type: "date", filterable: true, sortable: true, align: "center" },
        { header: "Process", accessor: "Process", type: "text", filterable: true, sortable: true, align: "center" },
        { header: "Clo. Carat", accessor: "Close_Carat", type: "number", filterable: true, sortable: true, align: "right", fraction: 3 },

    ]
    const alwaysKeep = [
        "Disp_Carat",
        "Rate",
        "Trn_Date",
        "Process",
        "Close_Carat",
    ];

    const filteredColumns = useMemo(() => {
        return columns.filter(({ accessor }) =>
            mixStockRptDetail?.params.includes(accessor) || alwaysKeep.includes(accessor))
    }, [mixStockRptDetail]);
    const {
        data = [],
        isError,
        isPending,
        mutate: filterStock,
    } = usePost({
        url: apiRoute.stockEntry.fetchMixStock,
        queryKey: "GetStock",
        onSuccessTasks: (data) => {
         //   console.log(data)
        }

    })
    const handleClickPrev = () => {
        navi(linksUrl.stockEntry.getMixStock + "/mix",)
    }
    useEffect(() => {
        if (mixStockRptDetail && mixStockRptDetail?.params?.length > 0) {

            let filter = ""
            let field = ""
            for (let i = 0; i < mixStockRptDetail?.params.length; i++) {
                field = mixStockRptDetail?.params[i];
                filter += ` and ${field}=''${mixStockRptDetail?.data[field]}''`
            }

            filterStock({
                data: {
                    action: 'Detail',
                    comp_code: compCode.join(","),
                    trade_of: 'P',
                    stock_param: mixStockRptDetail?.params,
                    filter_clause: `${filter}`
                }
            })
        }
    }, [mixStockRptDetail])

    if (isError) {
        return <ErrorCard />
    }
    if (isPending) {
        return <LoadingCard />
    }
    return (
        <MainContainer
            pageName={"Mix Stock Detail"}
            breadcrumbs={["Mix Stock", `Detail Report`]}
            prevPage={{ show: true, onClick: handleClickPrev }}>
            <div className={`  w-full  bg-white  min-h-screen shadow border-1 p-2   mb-2`}>
                {
                    data && data.length > 0 ?

                        <MasterGrid
                            columns={filteredColumns}
                            data={data}
                            className={""}
                            showPaging={true}
                            pageSize={50}
                            expandableRow={false}
                            headClass={"bg-stone-600 border-1 border-stone-300 text-white uppercase text-xs"}
                            filterClass={"bg-stone-200 border-1 border-slate-300"}
                            style={{ border: "1px solid red" }}
                            exportHeader={{
                                companyName: compName.join(","),
                                reportName: "MixStockDetailReport",

                            }}
                            PdfExpLayout="portrait"
                        ></MasterGrid> : ""}
            </div>
        </MainContainer>

    );
};

export default MixStockDetail;
